import React from "react";
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
  {
    icon: <FiActivity />,
    title: "Requirement Analysis",
    description:
      "We understand diverse industries deeply, ensuring our solutions are intuitive, robust, and cost-effective by prioritizing customer needs.",
  },
  {
    icon: <FiCast />,
    title: "Implementation",
    description:
      "We develop Mobile, Web, and Desktop apps using C/C++, Java, NodeJS, PHP, Python, .NET, and React on iOS, Android, Linux, and Windows.",
  },
  {
    icon: <FiMap />,
    title: "Quality Assurance",
    description:
      "We ensure top quality for Mobile Apps, Web Applications and Websites using frameworks like Selenium, TestNG, JUnit, and JMeter with robust testing.",
  },
  {
    icon: <FiCast />,
    title: "Deployment",
    description:
      "We deploy solutions on bare metal VMs, Docker containers, AWS, and Google Cloud Platform efficiently.",
  },
  {
    icon: <FiMap />,
    title: "CI / CD",
    description:
      "We automate Continuous Integration and Deployment with tools like Jenkins, Travis, and CircleCI to streamline workflows.",
  },
];

const WhatWeDo = ({ textAlign, serviceStyle }) => {
  return (
    <div className="row row--15 service-wrapper">
      {ServiceList.map((val, i) => (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
          <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeInOut"
            animateOnce={true}
          >
            <div className={`service ${serviceStyle} ${textAlign}`}>
              <div className="icon">{val.icon}</div>
              <div className="content">
                <h4
                  className="title w-600"
                  dangerouslySetInnerHTML={{ __html: val.title }}
                ></h4>
                <p
                  className="description b1 color-gray mb--0"
                  dangerouslySetInnerHTML={{ __html: val.description }}
                ></p>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      ))}
    </div>
  );
};
export default WhatWeDo;
